import React, { useState, useRef } from 'react';
import {Link} from 'react-router-dom';
import { motion, useScroll } from "framer-motion";
import ModalVideo from 'react-modal-video';

import { IMAGES, SVGICON } from '../constants/theme';

import LatestNewsSlider from '../components/LatestNewsSlider';
import NeedHelp from '../components/NeedHelp';
import ClientSlider from '../components/ClientSlider';

// summary cards for finance dashboard (used in place of crypto coin cards)
const cryotoCard = [
    {image: IMAGES.LogoIcon, title: 'Depositors', subtitle: 'Active accounts', price: '2,438', percent: '12'},
    {image: IMAGES.LogoIcon, title: 'Interest Due', subtitle: 'for each month', price: '$46,120', percent: '5'},
    {image: IMAGES.LogoIcon, title: 'Loans', subtitle: 'Outstanding', price: '$1,240,300', percent: '3'},
];

const iconWrapper = [
    {id:"1", title: 'User & Role Management', image: IMAGES.Doublehand,},
    {id:"2", title: 'Multi-Branch Operations', image: IMAGES.World,},
    {id:"3", title: 'Deposits & Interest Automation', image: IMAGES.ArrowCoin,}
];



function Home(){
    const [onHover, setOnHover] = useState('2');
    const [isOpen, setOpen] = useState(false)
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
      target: ref,
      offset: ["end end", "start start"]
    });

    return(
        <>
            <div className="page-content">		
                <div className="main-bnr">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-12">                               
                                <h1 className="wow fadeInUp" data-wow-delay="0.2s">Simplify Your Company’s Financial Operations </h1>
                                <p className="text text-primary wow fadeInUp" data-wow-delay="0.4s">Centralized control for Super Admins, Admins, Cashiers, and Staff with real-time interest and loan tracking.</p>
                                <div className="contant-box style-1 wow fadeInUp" data-wow-delay="0.6s">
                                    <a href="#contact-us" className="btn btn-lg  btn-shadow btn-primary m-r30">Request a Demo</a>
                                    <Link to={"/dashboard"} className="btn btn-lg btn-outline-primary">Login to Dashboard</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img className="shape1" src={IMAGES.BannerShape1} alt="" />
                </div>
                <div className="crypto-wrapper bg-light overflow-hidden" id="about-us">
                    <div className="container">
                        <div className="row">
                            {cryotoCard.map((data, index)=>(
                                <div className="col-lg-4 m-b30" key={index}>
                                    <div className="crypto-box wow fadeInUp" data-wow-delay="1.0s">
                                        <div className="crypto-media">
                                            <img src={data.image} alt="" />
                                        </div>
                                        <div className="crypto-info">
                                            <h5>{data.title} <span>{data.subtitle}</span></h5>
                                            <Link to={"/dashboard"} className="btn btn-square btn-primary " target="blank">
                                                {SVGICON.Arrow}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>   
                    </div>   
                </div> 
                <section className="content-inner coins-wrapper bg-light overflow-hidden">
                    <div className="container" >
                        <div className="row">
                            <div className="col-lg-12 m-b30">
                                    <div className="section-head wow fadeInUp" data-wow-delay="0.2s">
                                    <h2 className="title">With <span className="text-primary">Mindraft Tech</span><br/> centralize deposits, interest and loan operations</h2>
                                </div>
                                <h5 className="sub-title text-primary wow fadeInUp" data-wow-delay="0.4s" >Get company-wide control in minutes</h5>
                                <p className="m-t10">A unified dashboard to monitor deposits, loans, and branch performance at a glance.</p>
                                <ul className="list-style-1">
                                    <li className="wow fadeInUp" data-wow-delay="0.6s">Create branches, register staff and assign roles</li>
                                    <li className="wow fadeInUp" data-wow-delay="0.8s">Manage depositors and schedule interest payouts</li>
                                    <li className="wow fadeInUp" data-wow-delay="1.0s">Track loans, payments and defaulters centrally</li>
                                </ul>
                                <a href="#contact-us" className="btn btn-lg  btn-shadow btn-primary wow fadeInUp" data-wow-delay="1.2s">Request Demo</a>
                            </div>
                         
                        </div>
                    </div>
                    <div className="coin-wave">
                        <motion.div className="flex-coin1"                                
                            transition={{
                                ease: "linear",
                                duration: 0.5,
                                x: { duration: 0.7 }
                            }}                         
                            initial={{ opacity: 0 ,y: '500px'}}
                            whileInView={{ opacity: 1, y: 0}}
                        >
                            <img src={IMAGES.LogoIcon2} alt="" />
                        </motion.div>
                        
                        <motion.div 
                            className="flex-coin2" 
                            transition={{
                                ease: "linear",
                                duration: 0.5,
                                x: { duration: 0.7 }
                            }}                         
                            initial={{ opacity: 0 ,y: '200px'}}
                            whileInView={{ opacity: 1, y: 0}}
                        >
                            <img src={IMAGES.LogoIcon4} alt="" />
                        </motion.div>
                        <div className="flex-coin3" 
                            data-400="transform:translateY(300px); opacity:0;" data-800="transform:translateY(0); opacity:1;"
                            
                        >
                            <img src={IMAGES.LogoIcon1} alt="" />
                        </div>
                        <motion.div className="flex-coin4" data-300="transform:translateY(350px); opacity:0;" data-700="transform:translateY(0); opacity:1;"
                            transition={{
                                ease: "linear",
                                duration: 0.5,
                                x: { duration: 0.7 }
                            }}                         
                            initial={{ opacity: 0 ,y: '350px'}}
                            whileInView={{ opacity: 1, y: 0}}
                        >
                            <img src={IMAGES.LogoIcon3} alt="" />
                        </motion.div>
                        <motion.div className="flex-coin5" data-400="transform:translateY(300px); opacity:0;" data-800="transform:translateY(0); opacity:1;"
                            transition={{
                                ease: "linear",
                                duration: 0.5,
                                x: { duration: 0.7 }
                            }}                         
                            initial={{ opacity: 0 ,y: '300px'}}
                            whileInView={{ opacity: 1, y: 0}}
                        >
                            <img src={IMAGES.LogoIcon5} alt="" />
                        </motion.div>
                    </div>
                </section>
                
                <section className="content-inner how-it-works">
                    <div className="container">
                        <div className="section-head text-center">
                            <h2 className="title wow fadeInUp" data-wow-delay="0.2s">How It Works</h2>
                            <p className="sub-title wow fadeInUp" data-wow-delay="0.4s">A quick workflow to get your company running on the platform</p>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-6 m-b30">
                                <div className="icon-bx-wraper style-1 text-center">
                                    <div className="icon-media"><i className="fa fa-building fa-3x text-white z-99"></i></div>
                                    <div className="icon-content">
                                        <h4 className="title">1. Add Branches & Users</h4>
                                        <p>Company creates branches and assigns roles (Super Admin, Admin, Cashier, Staff).</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 m-b30">
                                <div className="icon-bx-wraper style-1 text-center">
                                    <div className="icon-media"><i className="fa fa-user-check fa-3x text-white z-99"></i></div>
                                    <div className="icon-content">
                                        <h4 className="title">2. Manage Depositors & Interest</h4>
                                        <p>Users register depositors, configure interest schedules and payout rules.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 m-b30">
                                <div className="icon-bx-wraper style-1 text-center">
                                    <div className="icon-media"><i className="fa fa-receipt fa-3x text-white z-99"></i></div>
                                    <div className="icon-content">
                                        <h4 className="title">3. Cashier Payments & Receipts</h4>
                                        <p>Cashiers process payments, issue receipts and record transactions securely.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 m-b30">
                                <div className="icon-bx-wraper style-1 text-center">
                                    <div className="icon-media"><i className="fa fa-file-invoice-dollar fa-3x text-white z-99"></i></div>
                                    <div className="icon-content">
                                        <h4 className="title">4. Admin Loan Monitoring</h4>
                                        <p>Admins track loan accounts, payments, and receive default alerts.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 m-b30">
                                <div className="icon-bx-wraper style-1 text-center">
                                    <div className="icon-media"><i className="fa fa-shield-alt fa-3x text-white z-99"></i></div>
                                    <div className="icon-content">
                                        <h4 className="title">5. Super Admin Oversight</h4>
                                        <p>Super Admin views company-wide reports, audit logs and manages security settings.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content-inner-2 content-bx style-1 ">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 m-b30 ">
                                <div className="dz-media">
                                    <img src={IMAGES.about1} alt="image" className="rounded" />
                                    <motion.div className="content-box wow bounceInLeft" data-wow-delay="0.6s"
                                        transition={{
                                            ease: "linear",
                                            duration: 0.5,
                                            x: { duration: 0.6 }
                                        }}                         
                                        initial={{ x: '-300px'}}
                                        whileInView={{ x: 0}}
                                    >
                                        <h6 className="m-a0">Access analytical <br/>branch & account data</h6>
                                    </motion.div>
                                </div>
                            </div>
                            <div className="col-lg-6 m-b30">
                                <div className="inner-content">
                                    <div className="section-head">
                                        <h3 className="title wow fadeInUp" data-wow-delay="0.6s">Enterprise-grade finance control<br/>for branches & staff</h3>
                                        <motion.p className="font-text wow fadeInUp" data-wow-delay="0.8s"
                                            initial={{ opacity: 0,  y: '100px' }}
                                            whileInView={{ opacity: 1,  y: '0' }}
                                            transition={{ duration: 0.7 }}
                                            >Manage deposit accounts, automate interest, verify documents, and monitor loan health across all branches.
                                        </motion.p>
                                    </div>
                                    
                                    <div className="contant-box style-1 p-t60" data-wow-delay="1.0s">
                                        <a href="#contact-us" className="btn btn-primary m-r30">REQUEST DEMO</a>
                                        <Link to={"#"} className="video-btn style-1 popup-youtube"                                        
                                            onClick={()=> setOpen(true)}
                                        >
                                            <i className="fa fa-play"></i>
                                            <span className="text">How it works</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content-inner overflow-hidden">
                    <div className="container">
                        <div className="section-head text-center">
                            <h2 className="title wow fadeInUp" data-wow-delay="0.4s">Why <span className="text-primary">Mindraft Tech?</span></h2>
                        </div>
                        <div className="row justify-content-center">
                            {iconWrapper.map((data, ind)=>(
                                <div className="col-lg-4 col-md-6 m-b30" key={ind}>
                                    <div className={`icon-bx-wraper style-1 box-hover text-center ${onHover === data.id ? 'active' : ''}`} data-wow-delay="0.6s" 
                                        onMouseOver={()=>setOnHover(data.id)}
                                    >
                                        <div className="icon-media"> 
                                            <img src={data.image} alt="" />
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="title">{data.title}</h4>
                                            <p>Lorem Ipsum has been the industry's standard dummy text ever.</p>
                                            <p>when an unknown printer took a galley of type and scrambledt.</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>    
                    </div>    
                </section>    
         
                <section className=" bg-light call-to-action pt-6 pb-6">
                    <div className="container">
                        <h2 className="title text-capitalize text-center p-b15 wow fadeInUp" data-wow-delay="0.6s">Deposit & Interest Calculator <br/> For Branches and Accounts</h2>
                        <div className="text-center"> 	
                            <a href="#contact-us" className="btn btn-primary btn-lg wow fadeInUp" data-wow-delay="0.8s">Request Demo</a>
                        </div> 	
                    </div>
                </section>
                <section id="contact-us" className="bg-primary content-inner-3 form-wrapper1">
                    <div className="container">
                        <NeedHelp />
                    </div>
                </section>                                
            </div>
            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="cfmQFW1DpA0" onClose={() => setOpen(false)} />
        </>
    )
}
export default Home;